import { meshCoverageRuntime } from '../core/mesh-coverage-runtime';
import { getMapLegendRegistry, renderMapLegend } from '../core/map-legend-registry';
import { MAP_LEGEND_DEFINITIONS } from '../core/map-legend-definitions';
import { createLayerGroupControl, createLayerGroupCount, syncLayerGroupControl } from './layer-group';
import OrthoLayer from '../layers/OrthoLayer';
import GesutLayer from '../layers/GesutLayer';
import PortPolskaLayer from '../layers/PortPolskaLayer';
import SidusisLayer from '../layers/SidusisLayer';
import EducationFacilitiesLayer, { educationLayerInfoHtml } from '../layers/EducationFacilitiesLayer';
import MpzpLayer from '../layers/MpzpLayer';
import MpzpImportedLayer from '../layers/MpzpImportedLayer';
import PogLayer from '../layers/PogLayer';
import StudiumLayer from '../layers/StudiumLayer';
import PowodzLayer from '../layers/PowodzLayer';
import KowrLayer from '../layers/KowrLayer';
import OwnershipLayer from '../layers/OwnershipLayer';
import LandUseLayer from '../layers/LandUseLayer';
import { kowrLayerRuntime } from '../core/kowr-layer-runtime';
import { educationLayerRuntime } from '../core/education-layer-runtime';
import { ownershipLayerRuntime } from '../core/ownership-layer-runtime';
import { landUseLayerRuntime } from '../core/land-use-layer-runtime';
import { buildLayerSelectionChanges, LAYER_SELECTION_MODES } from '../core/layer-selection';
import { noiseLayerRuntime } from '../core/noise-layer-runtime';
import TransactionsLayer from '../layers/TransactionsLayer';
import SignalsLayer from '../layers/SignalsLayer';
import ListingsLayer from '../layers/ListingsLayer';
import DeveloperOffersLayer from '../layers/DeveloperOffersLayer';
import DzialkiLayer from '../layers/DzialkiLayer';
import BudynkiLayer from '../layers/BudynkiLayer';
import GunbLayer from '../layers/GunbLayer';
import OtoczenieLayer from '../layers/OtoczenieLayer';

export const LAYER_DEFINITIONS = [
    { key: 'widoki3d', label: 'Widoki 3D', ariaLabel: 'Przełącz pokrycie widoków trójwymiarowych',
      svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="1.5" y="4" width="21" height="16" rx="4"/><text x="12" y="15.2" fill="currentColor" stroke="none" text-anchor="middle" font-family="system-ui, sans-serif" font-size="9.5" font-weight="800" letter-spacing="-0.35">3D</text></svg>', minZoom: 0, className: 'nm-layer-toggle--blue' },
    {
        key: 'ortho',
        label: 'Satelita (Ortofotomapa)',
        ariaLabel: 'Prze\u0142\u0105cz widok satelitarny',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>',
        minZoom: OrthoLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--orange'
    },
    {
        key: 'mpzp',
        label: 'Miejscowy plan zagospodarowania przestrzennego — Geoportal',
        ariaLabel: 'Prze\u0142\u0105cz rastrow\u0105 warstw\u0119 miejscowych plan\u00f3w zagospodarowania przestrzennego z Geoportalu',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M3 15h18"/><path d="M9 3v18"/></svg>',
        minZoom: MpzpLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--planning',
        group: 'planning'
    },
    {
        key: 'mpzpRu',
        label: 'Miejscowy plan zagospodarowania przestrzennego — Rejestr urbanistyczny',
        ariaLabel: 'Prze\u0142\u0105cz przeznaczenia z miejscowych plan\u00f3w zagospodarowania przestrzennego zaimportowanych z Rejestru urbanistycznego',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14"/><path d="M4 9h16"/><path d="M9 3v16"/><path d="m13 14 2 2 4-5"/></svg>',
        minZoom: MpzpImportedLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--planning',
        group: 'planning'
    },
    {
        key: 'pog',
        label: 'Plan ogólny - Rejestr Urbanistyczny',
        ariaLabel: 'Przełącz podgląd planu ogólnego',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6.5 9 4l6 2.5 6-2.5v13.5L15 20l-6-2.5-6 2.5z"/><path d="M9 4v13.5"/><path d="M15 6.5V20"/><path d="m5.5 9.5 11 4"/></svg>',
        minZoom: PogLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--planning',
        group: 'planning'
    },
    {
        key: 'studium',
        label: 'Studium uwarunkowa\u0144 i kierunk\u00f3w zagospodarowania przestrzennego — Geoportal',
        ariaLabel: 'Prze\u0142\u0105cz studium uwarunkowa\u0144 i kierunk\u00f3w zagospodarowania przestrzennego',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>',
        minZoom: StudiumLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--planning',
        group: 'planning'
    },
    {
        key: 'portPolska',
        label: 'Plany rezerwacji terenu i zakazy inwestycyjne Port Polska',
        ariaLabel: 'Przełącz plany rezerwacji terenu i zakazy inwestycyjne Port Polska',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 5h18v14H3z" stroke-dasharray="3 2"/><path d="m8 9 8 6"/><path d="m16 9-8 6"/></svg>',
        minZoom: PortPolskaLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--planning',
        group: 'planning'
    },
    {
        key: 'powodz',
        label: 'Zagro\u017cenia powodziowe',
        ariaLabel: 'Prze\u0142\u0105cz trzy scenariusze zagro\u017cenia powodziowego',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l-3.6 7.2L2 11.4l4.5 5.4L5 22l7-3.5L19 22l-1.5-5.2 4.5-5.4-6.4-2.2z"/></svg>',
        minZoom: PowodzLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--flood'
    },
    {
        key: 'gesut',
        label: 'Geodezyjna ewidencja sieci uzbrojenia terenu',
        ariaLabel: 'Prze\u0142\u0105cz uzbrojenie terenu',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/></svg>',
        minZoom: GesutLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--orange',
        group: 'infrastructure'
    },
    {
        key: 'sidusis',
        label: 'Dostępność internetu stacjonarnego',
        ariaLabel: 'Przełącz dostępność stacjonarnego internetu szerokopasmowego',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5a10 10 0 0 1 14 0"/><path d="M8 16a6 6 0 0 1 8 0"/><path d="M11 19.5a2 2 0 0 1 2 0"/></svg>',
        minZoom: SidusisLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--blue',
        group: 'infrastructure'
    },
    {
        key: 'education',
        label: 'Szkoły, przedszkola i żłobki',
        ariaLabel: 'Przełącz szkoły, przedszkola i żłobki',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 9 12 4 2 9l10 5 10-5Z"/><path d="M6 11.2V16c0 1.7 2.7 3 6 3s6-1.3 6-3v-4.8"/><path d="M22 9v6"/></svg>',
        minZoom: EducationFacilitiesLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--orange',
        group: 'infrastructure'
    },
    {
        key: 'kowr',
        label: 'Działki w zasobie Krajowego Ośrodka Wsparcia Rolnictwa',
        ariaLabel: 'Przełącz działki w zasobie Krajowego Ośrodka Wsparcia Rolnictwa',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 20h18"/><path d="m5 17 4-9 4 6 3-5 3 8"/><path d="M9 8h6"/></svg>',
        minZoom: KowrLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--kowr'
    },
    {
        key: 'ownership',
        label: 'Mapa własności',
        ariaLabel: 'Przełącz Mapę własności działek',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 5.5 9 3l6 2.5L21 3v15.5L15 21l-6-2.5L3 21z"/><path d="M9 3v15.5"/><path d="M15 5.5V21"/><path d="m4.5 12 4.5-2 6 3 4.5-2"/></svg>',
        minZoom: OwnershipLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--orange',
        group: 'parcels'
    },
    {
        key: 'landUse',
        label: 'Użytki gruntowe',
        ariaLabel: 'Przełącz użytki gruntowe działek',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20c7-1 12-6 14-15 2 8-1 15-8 15H4Z"/><path d="M6 18c3-4 6-7 11-10"/></svg>',
        minZoom: LandUseLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--orange',
        group: 'parcels'
    },
    {
        key: 'dzialki',
        label: 'Granice dzia\u0142ek z Ewidencji Grunt\u00f3w i Budynk\u00f3w',
        ariaLabel: 'Prze\u0142\u0105cz granice dzia\u0142ek',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>',
        minZoom: DzialkiLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--orange'
    },
    {
        key: 'gunb',
        label: 'Pozwolenia na budow\u0119 z Rejestru G\u0142\u00f3wnego Urz\u0119du Nadzoru Budowlanego',
        ariaLabel: 'Prze\u0142\u0105cz pozwolenia na budow\u0119',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/><path d="M9 9h1"/><path d="M9 13h1"/><path d="M9 17h1"/></svg>',
        minZoom: GunbLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--purple'
    },
    {
        key: 'transakcje',
        label: 'Transakcje',
        ariaLabel: 'Prze\u0142\u0105cz warstw\u0119 transakcji',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
        minZoom: TransactionsLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--blue'
    },
    {
        key: 'sygnaly',
        label: 'Sygnały społeczności',
        ariaLabel: 'Przełącz warstwę sygnałów społeczności',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 13a6 6 0 0 1 12 0c0 5-6 9-6 9s-6-4-6-9Z"/><circle cx="12" cy="13" r="2.5"/></svg>',
        minZoom: SignalsLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--orange'
    },
    {
        key: 'ogloszenia',
        label: 'Ogłoszenia',
        ariaLabel: 'Przełącz warstwę ogłoszeń nieruchomości',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20V9l8-6 8 6v11"/><path d="M9 20v-6h6v6"/><path d="M7 10h10"/></svg>',
        minZoom: ListingsLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--listing'
    },
    {
        key: 'ofertyDeweloperow',
        label: 'Oferty deweloperów',
        ariaLabel: 'Przełącz warstwę cen ofertowych mieszkań i domów od deweloperów',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M5 21V8l7-4 7 4v13"/><path d="M9 21v-5h6v5"/><path d="M12 8.5v4"/><path d="M13.5 9.5h-2a1 1 0 0 0 0 2h1a1 1 0 0 1 0 2h-2"/></svg>',
        minZoom: DeveloperOffersLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--developer-offer'
    },
    {
        key: 'budynki',
        label: 'Budynki z Ewidencji Grunt\u00f3w i Budynk\u00f3w',
        ariaLabel: 'Prze\u0142\u0105cz budynki',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"/><path d="M9 8h1"/><path d="M9 12h1"/><path d="M9 16h1"/><path d="M14 8h1"/><path d="M14 12h1"/><path d="M14 16h1"/><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16"/></svg>',
        minZoom: BudynkiLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--orange'
    },
    {
        key: 'otoczenie',
        label: 'Otoczenie',
        ariaLabel: 'Prze\u0142\u0105cz warstw\u0119 otoczenia',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>',
        minZoom: OtoczenieLayer.MIN_ZOOM,
        className: 'nm-layer-toggle--otoczenie'
    }
];

const LAYER_DESCRIPTIONS = {
    widoki3d: 'Zielony kolor pokazuje zasięg szczegółowych modeli opublikowanych w Geoportalu. Jasnoniebieski oznacza tryb uproszczony oparty na dostępnych budynkach Ewidencji Gruntów i Budynków. Kliknij miejsce, aby uruchomić symulację nasłonecznienia. Pełne modele pobieramy dopiero w symulacji.',
    ortho: 'Zdjęcia lotnicze udostępniane przez Geoportal pozwalają porównać zabudowę i sposób użytkowania terenu. Data wykonania zdjęć zależy od obszaru; obraz nie musi przedstawiać obecnego stanu.',
    portPolska: 'Obszary objęte planami rezerwacji terenu zatwierdzonymi zarządzeniami wojewodów oraz zakazami inwestycyjnymi wprowadzonymi na wniosek spółki Port Polska (dawniej Centralny Port Komunikacyjny). Na terenie objętym planem rezerwacji co do zasady nie wydaje się pozwoleń na budowę, decyzji o warunkach zabudowy ani decyzji o podziale nieruchomości. Zasięgi pochodzą z usługi Geoportalu i mogą pojawiać się z opóźnieniem względem publikacji zarządzenia; przed decyzją sprawdź treść aktu i aktualny stan w urzędzie wojewódzkim.',
    gesut: 'Sieci uzbrojenia terenu z usług Geoportalu: między innymi przewody wodociągowe, kanalizacyjne i energetyczne. Dostępność zależy od danych udostępnionych dla danego obszaru. Podgląd nie potwierdza możliwości przyłączenia nieruchomości.',
    sidusis: 'Deklarowana dostępność stacjonarnego internetu szerokopasmowego według Systemu Informacyjnego o Dostępie do Usług Stacjonarnego Internetu Szerokopasmowego Ministerstwa Cyfryzacji (internet.gov.pl). Od poziomu przybliżenia 13 usługa pokazuje budynki, a przy większym przybliżeniu także punkty adresowe (zwykle od poziomu 17). Zakres szczegółów zależy od skali obrazu określanej przez źródło. Dane mają charakter informacyjny; rzeczywistą możliwość i warunki świadczenia usługi należy potwierdzić u operatora.',
    ownership: 'Kolory pokazują kategorię właściciela lub władającego według grup rejestrowych Ewidencji Gruntów i Budynków. Nie wskazują konkretnej osoby ani firmy i nie potwierdzają tytułu prawnego. Brak kategorii nie oznacza własności prywatnej ani publicznej.',
    landUse: 'Kolory grupują kody użytków gruntowych zapisane bezpośrednio w Ewidencji Gruntów i Budynków. Działki z kilkoma kodami są oznaczane jako użytki mieszane, ponieważ dane bez powierzchni części nie pozwalają uczciwie wskazać użytku dominującego.',
    dzialki: 'Granice i identyfikatory działek z Ewidencji Gruntów i Budynków pomagają znaleźć nieruchomość i powiązane z nią obiekty. Podgląd na mapie nie zastępuje urzędowego wypisu ani ustalenia granic w terenie.',
    gunb: 'Dane Rejestru Wniosków, Decyzji i Zgłoszeń Głównego Urzędu Nadzoru Budowlanego pomagają sprawdzić planowane inwestycje w okolicy. Wpis lub wydanie pozwolenia nie oznacza, że budowa rozpoczęła się lub została ukończona.',
    transakcje: 'Ceny i informacje o sprzedaży nieruchomości z Rejestru Cen Nieruchomości. Przy oddaleniu mapa grupuje transakcje, a po przybliżeniu pozwala przeglądać szczegóły. Wyświetlane dane zależą od wybranych filtrów i dostępności danych źródłowych.',
    sygnaly: 'Zgłoszenia użytkowników o okolicy, publikowane po moderacji. Mogą pomóc zwrócić uwagę na lokalne warunki, ale nie są urzędowym potwierdzeniem ani niezależnie zweryfikowaną oceną. Sprawdź datę, opis i źródła konkretnego zgłoszenia.',
    ogloszenia: 'Oferty sprzedaży i wynajmu nieruchomości dostępne w Metroskopie. Ceny są cenami ofertowymi, czyli kwotami proponowanymi przez ogłoszeniodawców przed zawarciem transakcji. Lokalizacja może być przybliżona; dostępność i warunki należy potwierdzić u ogłoszeniodawcy.',
    ofertyDeweloperow: 'Ceny ofertowe mieszkań i domów na podstawie publikowanych danych deweloperów. Warstwa pomaga porównywać oferty inwestycji; cena ofertowa nie jest ceną zawartej transakcji. Szczegóły i dostępność potwierdź u dewelopera.',
    budynki: 'Obrysy i informacje o budynkach z Ewidencji Gruntów i Budynków. Pozwalają sprawdzić zabudowę działki i powiązane dane. Zakres informacji oraz ich aktualność zależą od źródła ewidencyjnego.',
    otoczenie: 'Obiekty z Bazy Danych Obiektów Topograficznych: między innymi drogi, wody, zabudowa i infrastruktura. Pomagają rozpoznać sąsiedztwo nieruchomości. Brak obiektu na mapie nie potwierdza jego braku w terenie.'
};

// Help of layers that bring their own markup (source, placement, gaps and use).
const LAYER_INFO_HTML = {
    education: educationLayerInfoHtml
};

const DESIRED_STATE_KEYS = {
    widoki3d: 'widoki3dDesired',
    ortho: 'orthoDesired',
    mpzp: 'mpzpDesired',
    mpzpRu: 'mpzpRuDesired',
    pog: 'pogDesired',
    studium: 'studiumDesired',
    powodz: 'powodzDesired',
    gesut: 'gesutDesired',
    portPolska: 'portPolskaDesired',
    sidusis: 'sidusisDesired',
    education: 'educationDesired',
    kowr: 'kowrDesired',
    ownership: 'ownershipDesired',
    landUse: 'landUseDesired',
    dzialki: 'dzialkiDesired',
    gunb: 'gunbDesired',
    transakcje: 'transakcjeDesired',
    sygnaly: 'sygnalyDesired',
    ogloszenia: 'ogloszeniaDesired',
    ofertyDeweloperow: 'ofertyDeweloperowDesired',
    budynki: 'budynkiDesired',
    otoczenie: 'otoczenieDesired',
    noiseLdwn: 'noiseLdwnDesired',
    noiseLn: 'noiseLnDesired',
    noiseMonitoring: 'noiseMonitoringDesired'
};

const ACTIVE_STATE_KEYS = {
    widoki3d: 'widoki3dActive',
    ortho: 'orthoActive',
    mpzp: 'mpzpActive',
    mpzpRu: 'mpzpRuActive',
    pog: 'pogActive',
    studium: 'studiumActive',
    powodz: 'powodzActive',
    gesut: 'gesutActive',
    portPolska: 'portPolskaActive',
    sidusis: 'sidusisActive',
    education: 'educationActive',
    kowr: 'kowrActive',
    ownership: 'ownershipActive',
    landUse: 'landUseActive',
    dzialki: 'dzialkiActive',
    gunb: 'gunbActive',
    transakcje: 'transakcjeActive',
    sygnaly: 'sygnalyActive',
    ogloszenia: 'ogloszeniaActive',
    ofertyDeweloperow: 'ofertyDeweloperowActive',
    budynki: 'budynkiActive',
    otoczenie: 'otoczenieActive'
};

const JSON_LAYER_KEYS = new Set([
    'mpzpRu', 'dzialki', 'gunb', 'transakcje', 'sygnaly', 'ogloszenia',
    'ofertyDeweloperow', 'budynki', 'otoczenie', 'education'
]);

const BADGE_LAYER_KEYS = ['widoki3d', 'ortho', 'mpzp', 'mpzpRu', 'pog', 'studium', 'powodz', 'portPolska', 'gesut', 'sidusis', 'education', 'kowr', 'ownership', 'landUse', 'transakcje', 'sygnaly', 'ogloszenia', 'ofertyDeweloperow', 'dzialki', 'budynki', 'gunb', 'otoczenie', 'noiseLdwn', 'noiseLn', 'noiseMonitoring'];

export function countDesiredBadgeLayers(state) {
    return BADGE_LAYER_KEYS.reduce(function(total, key) {
        return total + (state[DESIRED_STATE_KEYS[key]] ? 1 : 0);
    }, 0);
}

export const LAYER_GROUPS = [
    {
        key: 'planning',
        label: 'Planowanie przestrzenne',
        description: 'Miejscowy plan zagospodarowania przestrzennego, plan ogólny gminy, studium oraz rezerwacje terenu Port Polska z różnych źródeł danych',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19V5a2 2 0 0 1 2-2h8l6 6v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/><path d="M14 3v6h6"/><path d="M8 13h8"/><path d="M8 17h5"/></svg>'
    },
    {
        key: 'infrastructure',
        label: 'Infrastruktura',
        description: 'Sieci uzbrojenia terenu, dostępność internetu oraz szkoły, przedszkola i żłobki',
        svgHtml: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/></svg>'
    },
    {
        key: 'parcels',
        rootLayerKey: 'dzialki',
        label: 'Granice działek z Ewidencji Gruntów i Budynków',
        selectionMode: LAYER_SELECTION_MODES.EXCLUSIVE,
        keepOpenWhileSelected: true
    }
];

function definitionsForGroup(groupKey) {
    return LAYER_DEFINITIONS.filter(function(definition) {
        return definition.group === groupKey;
    });
}

function groupForRootLayer(layerKey) {
    return LAYER_GROUPS.find(function(group) {
        return group.rootLayerKey === layerKey;
    });
}

export function shouldKeepLayerGroupOpen(group, selectedCount) {
    return !!(group && group.keepOpenWhileSelected && selectedCount > 0);
}

function syncLayerDisabledState(el, minZoom, currentZoom, desired) {
    if (!el) return;
    el.classList.toggle('is-disabled', currentZoom < minZoom);
    el.classList.toggle('is-desired', !!desired);
}

export function createLayerPanel(config) {
    var layerPanelOpen = false;
    var layerTogglesEl = null;
    var layerTriggerEl = null;
    var layerPanelEl = null;
    var layerTooltipEl = null;
    var layerTooltipTimer = null;
    var layerZoomEl = null;
    var layerBadgeEl = null;
    var legendOptionEl = null;
    var legendToggleEl = null;
    var legendCountEl = null;
    var legendRegistry = null;
    var toggleEls = {};
    var toggleLayerFns = {};
    var infoEls = {};
    var infoTriggerEls = {};
    var groupOpen = {};
    var groupEls = {};
    var groupTriggerEls = {};
    var groupCountEls = {};
    var groupBlockingHintTimers = {};
    var openInfoKey = null;

    function getState() {
        return Object.assign(
            {},
            config.getState ? config.getState() : {},
            kowrLayerRuntime.getState(),
            educationLayerRuntime.getState(),
            ownershipLayerRuntime.getState(),
            landUseLayerRuntime.getState(),
            meshCoverageRuntime.getState(),
            noiseLayerRuntime.getState()
        );
    }

    function hideLayerTooltip() {
        if (!layerTooltipEl) return;
        layerTooltipEl.classList.remove('is-visible');
        if (layerTooltipTimer) {
            clearTimeout(layerTooltipTimer);
            layerTooltipTimer = null;
        }
    }

    function toggleLayerPanel() {
        layerPanelOpen = !layerPanelOpen;
        if (layerPanelEl) layerPanelEl.classList.toggle('is-open', layerPanelOpen);
        if (layerTriggerEl) layerTriggerEl.classList.toggle('is-active', layerPanelOpen);
        if (!layerPanelOpen) {
            hideLayerTooltip();
            closeInfoPanels();
        }
    }

    function closeInfoPanels() {
        openInfoKey = null;
        Object.keys(infoEls).forEach(function(key) {
            if (infoEls[key]) {
                infoEls[key].classList.remove('is-visible');
            }
        });
        Object.keys(infoTriggerEls).forEach(function(key) {
            if (infoTriggerEls[key]) {
                infoTriggerEls[key].classList.remove('is-active');
            }
        });
    }

    function toggleInfoPanel(key) {
        openInfoKey = openInfoKey === key ? null : key;
        syncVisibility();
    }

    function toggleLayerGroup(key) {
        var group = LAYER_GROUPS.find(function(candidate) { return candidate.key === key; });
        var state = getState();
        var selectedCount = definitionsForGroup(key).reduce(function(total, definition) {
            return total + (state[DESIRED_STATE_KEYS[definition.key]] ? 1 : 0);
        }, 0);
        if (shouldKeepLayerGroupOpen(group, selectedCount)) {
            definitionsForGroup(key).forEach(function(definition) {
                if (!state[DESIRED_STATE_KEYS[definition.key]]) return;
                var toggleEl = toggleEls[definition.key];
                if (!toggleEl) return;

                if (groupBlockingHintTimers[definition.key]) {
                    clearTimeout(groupBlockingHintTimers[definition.key]);
                }
                toggleEl.classList.remove('is-blocking-hint');
                void toggleEl.offsetWidth;
                toggleEl.classList.add('is-blocking-hint');
                groupBlockingHintTimers[definition.key] = setTimeout(function() {
                    toggleEl.classList.remove('is-blocking-hint');
                    groupBlockingHintTimers[definition.key] = null;
                }, 700);
            });
            groupOpen[key] = true;
            syncVisibility();
            return;
        }
        groupOpen[key] = !groupOpen[key];
        syncVisibility();
    }

    function showLayerTooltip(label, minZoom, anchorEl) {
        if (!layerTooltipEl) return;
        if (layerTooltipTimer) clearTimeout(layerTooltipTimer);
        var hint = config.mapZoom() < minZoom ? 'przybli\u017c' : 'oddal';
        layerTooltipEl.textContent = hint + ' do zoom ' + minZoom;
        if (anchorEl && anchorEl.getBoundingClientRect) {
            var rect = anchorEl.getBoundingClientRect();
            layerTooltipEl.style.top = Math.max(12, Math.min(window.innerHeight - 52, rect.bottom + 6)) + 'px';
            layerTooltipEl.style.right = Math.max(12, window.innerWidth - rect.right) + 'px';
        }
        layerTooltipEl.classList.add('is-visible');
        layerTooltipTimer = setTimeout(hideLayerTooltip, 3000);
    }

    function syncLayerBadge() {
        if (!layerBadgeEl) return;
        var state = getState();
        var count = countDesiredBadgeLayers(state);
        layerBadgeEl.textContent = count;
        layerBadgeEl.classList.toggle('is-visible', count > 0);
    }

    function getLegendRegistry() {
        if (!legendRegistry) {
            var map = config.getMap && config.getMap();
            legendRegistry = getMapLegendRegistry(map);
        }
        return legendRegistry;
    }

    function syncLegendToggle(state) {
        if (!legendToggleEl) return;
        legendToggleEl.checked = !!state.opened;
        legendToggleEl.disabled = state.count === 0;
        if (legendOptionEl) legendOptionEl.classList.toggle('is-disabled', state.count === 0);
        if (legendCountEl) {
            var lastTwoDigits = state.count % 100;
            var lastDigit = state.count % 10;
            var suffix = state.count === 1
                ? 'sekcja'
                : (lastTwoDigits < 12 || lastTwoDigits > 14) && lastDigit >= 2 && lastDigit <= 4
                    ? 'sekcje'
                    : 'sekcji';
            legendCountEl.textContent = state.count + ' ' + suffix;
        }
    }

    function syncMapLegends() {
        var registry = getLegendRegistry();
        if (!registry) return;
        var state = getState();
        Object.keys(MAP_LEGEND_DEFINITIONS).forEach(function(key) {
            var definition = MAP_LEGEND_DEFINITIONS[key];
            var activeStateKey = ACTIVE_STATE_KEYS[key];
            registry.setVisible('layer:' + key, key, !!(activeStateKey && state[activeStateKey]), {
                className: 'ms-map-legend--' + key,
                ariaLabel: 'Legenda warstwy ' + definition.title,
                render: function(element) { renderMapLegend(element, definition); },
            });
        });
    }

    function syncVisibility() {
        if (!config.getMap || !config.getMap()) return;

        var zoom = config.mapZoom();
        var state = getState();
        if (layerZoomEl) layerZoomEl.textContent = 'Zoom: ' + zoom.toFixed(1);
        LAYER_DEFINITIONS.forEach(function(definition) {
            if (toggleEls[definition.key] && ACTIVE_STATE_KEYS[definition.key]) {
                toggleEls[definition.key].classList.toggle('is-active', !!state[ACTIVE_STATE_KEYS[definition.key]]);
                toggleEls[definition.key].setAttribute('aria-checked', state[DESIRED_STATE_KEYS[definition.key]] ? 'true' : 'false');
            }
        });

        LAYER_DEFINITIONS.forEach(function(definition) {
            syncLayerDisabledState(
                toggleEls[definition.key],
                definition.minZoom,
                zoom,
                state[DESIRED_STATE_KEYS[definition.key]]
            );
        });

        LAYER_DEFINITIONS.forEach(function(definition) {
            var syncFn = config.syncLayerVisibility && config.syncLayerVisibility[definition.key];
            if (typeof syncFn === 'function') {
                syncFn();
                return;
            }
            if (definition.key === 'widoki3d') {
                const controller = meshCoverageRuntime.getController();
                if (controller) controller.syncVisibility();
            }
            if (definition.key === 'kowr') {
                var kowrController = kowrLayerRuntime.getController();
                if (kowrController) kowrController.syncVisibility();
            }
            if (definition.key === 'education') {
                var educationController = educationLayerRuntime.getController();
                if (educationController) educationController.syncVisibility();
            }
            if (definition.key === 'ownership') {
                var ownershipController = ownershipLayerRuntime.getController();
                if (ownershipController) ownershipController.syncVisibility();
            }
            if (definition.key === 'landUse') {
                var landUseController = landUseLayerRuntime.getController();
                if (landUseController) landUseController.syncVisibility();
            }
        });

        LAYER_DEFINITIONS.forEach(function(definition) {
            var infoEl = infoEls[definition.key];
            var infoFn = (config.getLayerInfoHtml && config.getLayerInfoHtml[definition.key]) || LAYER_INFO_HTML[definition.key];
            var triggerEl = infoTriggerEls[definition.key];
            var html = typeof infoFn === 'function' ? infoFn(state, definition)
                : '<p>' + (LAYER_DESCRIPTIONS[definition.key] || '') + '</p>';
            html += '<p>Możesz wybrać warstwę przy dowolnym przybliżeniu. Zaznaczenie oznacza Twój wybór, a kolor przycisku oznacza wyświetlanie warstwy. '
                + (definition.minZoom > 0 ? 'Warstwa jest wyświetlana od poziomu przybliżenia ' + definition.minZoom + '.' : 'Warstwa jest dostępna przy każdym przybliżeniu.') + '</p>';

            if (!infoEl) {
                return;
            }

            infoEl.innerHTML = html || '';
            if (!html && openInfoKey === definition.key) {
                openInfoKey = null;
            }

            infoEl.classList.toggle('is-visible', openInfoKey === definition.key && !!html);
            if (triggerEl) {
                triggerEl.disabled = !html;
                triggerEl.classList.toggle('is-active', openInfoKey === definition.key && !!html);
            }
        });

        syncLayerGroups();

        syncLayerBadge();
        syncMapLegends();
    }

    function syncLayerGroups() {
        var state = getState();
        LAYER_GROUPS.forEach(function(group) {
            var groupDefinitions = definitionsForGroup(group.key);
            var activeCount = groupDefinitions.reduce(function(total, definition) {
                return total + (state[DESIRED_STATE_KEYS[definition.key]] ? 1 : 0);
            }, 0);
            var isLockedOpen = shouldKeepLayerGroupOpen(group, activeCount);
            if (isLockedOpen) groupOpen[group.key] = true;
            var isOpen = !!groupOpen[group.key];
            var rootDefinition = group.rootLayerKey
                ? LAYER_DEFINITIONS.find(function(definition) { return definition.key === group.rootLayerKey; })
                : null;
            if (groupEls[group.key]) syncLayerGroupControl({
                root: groupEls[group.key], trigger: groupTriggerEls[group.key], count: groupCountEls[group.key], label: group.label,
            }, {
                opened: isOpen, locked: isLockedOpen, sublayers: !!group.rootLayerKey,
                selectedCount: activeCount + (rootDefinition && state[DESIRED_STATE_KEYS[rootDefinition.key]] ? 1 : 0),
            });
        });

    }

    function createLayerButton(definition) {
        var btn = document.createElement('button');
        var state = getState();
        var group = definition.group
            ? LAYER_GROUPS.find(function(candidate) { return candidate.key === definition.group; })
            : null;
        var selectionMode = group && group.selectionMode
            ? group.selectionMode
            : LAYER_SELECTION_MODES.MULTIPLE;
        var toggleFn = config.toggleLayer && config.toggleLayer[definition.key];
        if (definition.key === 'widoki3d') toggleFn = () => meshCoverageRuntime.getController()?.toggle();
        if (definition.key === 'kowr' && typeof toggleFn !== 'function') {
            toggleFn = function() {
                var kowrController = kowrLayerRuntime.getController();
                if (kowrController) kowrController.toggle();
            };
        }
        if (definition.key === 'education' && typeof toggleFn !== 'function') {
            toggleFn = function(options) {
                var educationController = educationLayerRuntime.getController();
                return educationController ? educationController.toggle(options) : false;
            };
        }
        if (definition.key === 'ownership' && typeof toggleFn !== 'function') {
            toggleFn = function(options) {
                var ownershipController = ownershipLayerRuntime.getController();
                return ownershipController ? ownershipController.toggle(options) : false;
            };
        }
        if (definition.key === 'landUse' && typeof toggleFn !== 'function') {
            toggleFn = function(options) {
                var landUseController = landUseLayerRuntime.getController();
                return landUseController ? landUseController.toggle(options) : false;
            };
        }
        toggleLayerFns[definition.key] = toggleFn;

        btn.type = 'button';
        btn.className = 'nm-layer-toggle';
        btn.classList.add(definition.className);
        btn.setAttribute('aria-label', definition.ariaLabel);
        btn.classList.add(selectionMode === LAYER_SELECTION_MODES.SINGLE
            ? 'nm-layer-toggle--radio'
            : 'nm-layer-toggle--checkbox');
        btn.setAttribute('role', selectionMode === LAYER_SELECTION_MODES.SINGLE ? 'radio' : 'checkbox');
        btn.setAttribute('data-layer-key', definition.key);
        btn.setAttribute('aria-checked', state[DESIRED_STATE_KEYS[definition.key]] ? 'true' : 'false');
        var loadingMarkup = JSON_LAYER_KEYS.has(definition.key)
            && (definition.key !== 'dzialki' || config.parcelRenderMode !== 'vector')
            ? '<span class="nm-layer-loading" aria-hidden="true"></span>'
            : '';
        btn.innerHTML = definition.svgHtml + '<span class="nm-layer-toggle-label">' + definition.label + '</span>'
            + loadingMarkup;

        if (ACTIVE_STATE_KEYS[definition.key] && state[ACTIVE_STATE_KEYS[definition.key]]) {
            btn.classList.add('is-active');
        }

        btn.addEventListener('click', function(event) {
            event.stopPropagation();
            if (!config.getMap || !config.getMap()) return;
            if (config.mapZoom() < definition.minZoom) {
                showLayerTooltip(definition.label, definition.minZoom, btn);
            } else {
                hideLayerTooltip();
            }
            if (typeof toggleFn !== 'function') return;

            var currentState = getState();
            var groupDefinitions = group ? definitionsForGroup(group.key) : [definition];
            var selectedKeys = groupDefinitions
                .filter(function(candidate) { return !!currentState[DESIRED_STATE_KEYS[candidate.key]]; })
                .map(function(candidate) { return candidate.key; });
            var changes = buildLayerSelectionChanges(selectionMode, definition.key, selectedKeys);

            changes.forEach(function(change, index) {
                var changeToggleFn = toggleLayerFns[change.key];
                if (typeof changeToggleFn !== 'function') return;
                changeToggleFn({ notify: index === changes.length - 1 });
            });
        });

        return btn;
    }

    function createLayerItem(definition) {
        toggleEls[definition.key] = createLayerButton(definition);

        var itemEl = document.createElement('div');
        var itemRowEl = document.createElement('div');
        itemEl.className = 'nm-layer-item';
        itemRowEl.className = 'nm-layer-item-row';
        infoTriggerEls[definition.key] = createInfoButton(definition);
        infoEls[definition.key] = document.createElement('div');
        infoEls[definition.key].className = 'nm-layer-info';
        itemRowEl.appendChild(toggleEls[definition.key]);
        itemRowEl.appendChild(infoTriggerEls[definition.key]);
        itemEl.appendChild(itemRowEl);
        itemEl.appendChild(infoEls[definition.key]);
        return itemEl;
    }

    function createLayerGroup(group) {
        if (group.rootLayerKey) {
            return createSelectableLayerGroup(group);
        }

        var control = createLayerGroupControl(group);
        var groupEl = control.root;
        var triggerEl = control.trigger;
        var countEl = control.count;
        var contentEl = control.content;

        groupOpen[group.key] = false;

        definitionsForGroup(group.key).forEach(function(definition) {
            contentEl.appendChild(createLayerItem(definition));
        });

        triggerEl.addEventListener('click', function(event) {
            event.stopPropagation();
            hideLayerTooltip();
            toggleLayerGroup(group.key);
        });


        groupEls[group.key] = groupEl;
        groupTriggerEls[group.key] = triggerEl;
        groupCountEls[group.key] = countEl;

        return groupEl;
    }

    function createSelectableLayerGroup(group) {
        var rootDefinition = LAYER_DEFINITIONS.find(function(definition) {
            return definition.key === group.rootLayerKey;
        });
        var groupEl = document.createElement('div');
        var rootItemEl = createLayerItem(rootDefinition);
        var rootRowEl = rootItemEl.querySelector('.nm-layer-item-row');
        var expandEl = document.createElement('button');
        var contentEl = document.createElement('div');
        var contentId = 'nm-layer-group-content-' + group.key;

        groupOpen[group.key] = false;
        groupEl.className = 'nm-layer-group nm-layer-group--selectable';
        groupEl.setAttribute('data-layer-group', group.key);
        contentEl.id = contentId;
        contentEl.className = 'nm-layer-group-content';
        if (group.selectionMode === LAYER_SELECTION_MODES.SINGLE) {
            contentEl.setAttribute('role', 'radiogroup');
            contentEl.setAttribute('aria-label', 'Podwarstwy: ' + group.label);
        }

        expandEl.type = 'button';
        expandEl.className = 'ms-button ms-button--icon nm-layer-group-expand';
        expandEl.setAttribute('aria-expanded', 'false');
        expandEl.setAttribute('aria-controls', contentId);
        expandEl.setAttribute('aria-label', 'Pokaż podwarstwy: ' + group.label);
        expandEl.innerHTML = '<span class="nm-layer-group-chevron" aria-hidden="true">⌄</span>';

        definitionsForGroup(group.key).forEach(function(definition) {
            contentEl.appendChild(createLayerItem(definition));
        });

        expandEl.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            hideLayerTooltip();
            toggleLayerGroup(group.key);
        });

        var countEl = createLayerGroupCount();
        rootRowEl.appendChild(countEl);
        rootRowEl.appendChild(expandEl);
        groupEl.appendChild(rootItemEl);
        groupEl.appendChild(contentEl);

        groupEls[group.key] = groupEl;
        groupTriggerEls[group.key] = expandEl;
        groupCountEls[group.key] = countEl;

        return groupEl;
    }

    function createInfoButton(definition) {
        var btn = document.createElement('button');

        btn.type = 'button';
        btn.className = 'ms-button ms-button--icon nm-layer-info-trigger';
        btn.setAttribute('aria-label', 'Pokaż informacje o źródle warstwy ' + definition.label);
        btn.innerHTML = '<span class="nm-layer-info-trigger__icon">i</span>';

        btn.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            hideLayerTooltip();
            toggleInfoPanel(definition.key);
        });

        return btn;
    }

    layerTogglesEl = document.createElement('div');
    layerTogglesEl.className = 'nm-layer-toggles';

    layerTriggerEl = document.createElement('button');
    layerTriggerEl.type = 'button';
    layerTriggerEl.className = 'nm-layer-trigger';
    layerTriggerEl.setAttribute('aria-label', 'Warstwy mapy');
    layerTriggerEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 2 7l10 5 10-5-10-5z"/><path d="m2 17 10 5 10-5"/><path d="m2 12 10 5 10-5"/></svg>';
    layerBadgeEl = document.createElement('span');
    layerBadgeEl.className = 'nm-layer-badge';
    layerTriggerEl.appendChild(layerBadgeEl);
    layerTriggerEl.addEventListener('click', function(event) {
        event.stopPropagation();
        toggleLayerPanel();
    });

    layerPanelEl = document.createElement('div');
    layerPanelEl.className = 'nm-layer-panel';
    var headerEl = document.createElement('div');
    headerEl.className = 'ms-layer-panel-header';
    headerEl.setAttribute('data-layer-panel-header', '');
    layerPanelEl.appendChild(headerEl);

    layerZoomEl = document.createElement('div');
    layerZoomEl.className = 'nm-layer-zoom';
    layerZoomEl.textContent = 'Zoom: ' + (config.getMap && config.getMap() ? config.mapZoom().toFixed(1) : '\u2014');
    headerEl.appendChild(layerZoomEl);

    legendOptionEl = document.createElement('label');
    legendOptionEl.className = 'nm-layer-legend-option';
    legendToggleEl = document.createElement('input');
    legendToggleEl.type = 'checkbox';
    legendToggleEl.setAttribute('aria-label', 'Pokaż legendę aktywnych warstw');
    var optionLegendRegistry = getLegendRegistry();
    if (optionLegendRegistry) legendToggleEl.setAttribute('aria-controls', optionLegendRegistry.drawer.id);
    var legendLabelEl = document.createElement('span');
    legendLabelEl.className = 'nm-layer-legend-option__label';
    legendLabelEl.textContent = 'Legenda';
    legendCountEl = document.createElement('small');
    legendCountEl.className = 'nm-layer-legend-option__count';
    legendCountEl.textContent = '0 sekcji';
    legendOptionEl.append(legendToggleEl, legendLabelEl, legendCountEl);
    legendToggleEl.addEventListener('change', function() {
        var registry = getLegendRegistry();
        if (!registry) return;
        if (legendToggleEl.checked) {
            // On desktop both drawers occupy the left side of the map.
            // Hand focus back to the visible trigger before opening the legend.
            if (layerPanelOpen) toggleLayerPanel();
            if (layerTriggerEl) layerTriggerEl.focus();
            registry.open();
        } else registry.close();
    });
    headerEl.appendChild(legendOptionEl);

    var contentEl = document.createElement('div');
    contentEl.className = 'ms-layer-panel-content';
    contentEl.setAttribute('data-layer-panel-content', '');
    layerPanelEl.appendChild(contentEl);

    var baseMapItemEl = document.createElement('div');
    baseMapItemEl.className = 'nm-layer-toggle nm-layer-toggle--orange is-active is-locked';
    baseMapItemEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7l6-3 6 3 6-3v13l-6 3-6-3-6 3z"/><path d="M9 4v13"/><path d="M15 7v13"/></svg><span class="nm-layer-toggle-label">Mapa bazowa</span>';
    contentEl.appendChild(baseMapItemEl);

    LAYER_GROUPS.forEach(function(group) {
        if (!group.rootLayerKey) {
            contentEl.appendChild(createLayerGroup(group));
        }
    });

    LAYER_DEFINITIONS.forEach(function(definition) {
        if (definition.group) {
            return;
        }
        var rootGroup = groupForRootLayer(definition.key);
        if (rootGroup) {
            contentEl.appendChild(createLayerGroup(rootGroup));
            return;
        }
        contentEl.appendChild(createLayerItem(definition));
    });

    layerTooltipEl = document.createElement('div');
    layerTooltipEl.className = 'nm-layer-tooltip';

    layerTogglesEl.appendChild(layerTriggerEl);
    layerTogglesEl.appendChild(layerPanelEl);
    layerTogglesEl.appendChild(layerTooltipEl);

    document.addEventListener('click', function(event) {
        if (layerPanelOpen && layerTogglesEl && !layerTogglesEl.contains(event.target)) {
            layerPanelOpen = false;
            if (layerPanelEl) layerPanelEl.classList.remove('is-open');
            if (layerTriggerEl) layerTriggerEl.classList.remove('is-active');
            hideLayerTooltip();
            closeInfoPanels();
        }
    });

    var container = document.querySelector('.nm-map-shell');
    if (container) container.appendChild(layerTogglesEl);

    noiseLayerRuntime.subscribeState(syncLayerBadge);
    var currentLegendRegistry = getLegendRegistry();
    if (currentLegendRegistry) currentLegendRegistry.subscribe(syncLegendToggle);
    syncVisibility();

    return {
        getToggleEl: function(key) {
            return toggleEls[key] || null;
        },
        syncBadge: function() { syncLayerBadge(); syncLayerGroups(); },
        syncLegends: syncMapLegends,
        syncVisibility: syncVisibility,
        setLoading: function(key, loading) {
            var button = toggleEls[key] || (typeof document !== 'undefined'
                ? document.querySelector('[data-noise-layer="' + key + '"]') : null);
            if (!button) return;
            button.classList.toggle('is-loading', !!loading);
            if (loading) button.setAttribute('aria-busy', 'true');
            else button.removeAttribute('aria-busy');
        }
    };
}
